import { useState } from "react";
import {
  browserLocalPersistence,
  signInWithEmailAndPassword,
  setPersistence,
} from "firebase/auth";
import { auth } from "@/firebaseConfig.js";
import Button from "./Button";
import { PasswordInput } from "./PasswordInput";
import { FirebaseError } from "firebase/app";
import { errorMessages } from "@/assets/data/firebaseErrorMessage";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const signIn = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Устанавливаем персистентность сессии для сохранения данных при перезапуске
      await setPersistence(auth, browserLocalPersistence);

      // Авторизация через email и пароль
      await signInWithEmailAndPassword(auth, email, password);

      setLoading(false);
    } catch (error) {
      setLoading(false);

      if (error instanceof FirebaseError) {
        const errorCode = error.message || "default";
        setErrorMessage(errorMessages[errorCode] || errorMessages.default);
      } else {
        setErrorMessage(errorMessages.default);
      }
    }
  };
  return (
    <>
      <h2 className="authentication-box__title">Sign In</h2>
      {errorMessage && (
        <p className="authentication-box__error"> {errorMessage} </p>
      )}

      <p>Get unlimited access and earn money </p>

      <input
        className={`input `}
        required
        value={email}
        id="email"
        name="email"
        type="email"
        placeholder="you@example.com"
        onChange={(event) => setEmail(event.target.value)}
      />

      <PasswordInput value={password} onChange={setPassword} />

      <p className="authentication-box__text">
        Forgot your password?{" "}
        <a className="authentication-box__link" href="/auth/reset">
          Click here
        </a>
      </p>

      <Button title={loading ? "Signing In..." : "Sign In"} onClick={signIn} />

      <p className="authentication-box__text">
        Don't have an account?{" "}
        <a className="authentication-box__link" href="/auth/sign-up">
          Sign Up
        </a>
      </p>
    </>
  );
};

export default Login;
